import React from "react";
import DishesPage from "../components/DishesPage";
import Layout from "../components/Layout";

export default function GetDishesPage() {
  return (
    <Layout variant="moreWidth">
      <DishesPage />
    </Layout>
  );
}
